/// <reference path="WebService.ts" />

interface WebService
{
    openBankingLink( ) : void ;    
    importMovementsFromAPI( account:BankAccount, beginDate:Date|null, endDate:Date|null, completion:any ) : void ;
    updateBalanceFromAPI( account:BankAccount, completion:any ) : void ;    
}

WebService.prototype.openBankingLink = function( ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/open-banking/generate-link";
    let r = new DLRequest ( url_str, {}, "GET" );
    r.execute( (json:any, error:any) => {
        if (error) {
            AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR","ERROR"), error);
            return;
        }
        const url = json["url"];
        window.open(url,'_blank');
    } );
}

WebService.prototype.importMovementsFromAPI = function( account:BankAccount, beginDate:Date|null, endDate:Date|null, completion:any ) : void
{
    let dates = "";
    if (beginDate != null) {
        let sdf = ( MUIWebApplication.sharedInstance().delegate as AppDelegate ).serverDateFormatter;        
        dates += "?from=" + sdf.stringFromDate(beginDate);
        if (endDate != null) dates += "&to=" + sdf.stringFromDate(endDate);
    }
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/open-banking/import-movements-from-bank-account/" + account.identifier + dates;
    let r = new DLRequest ( url_str, {}, "GET" );
    r.execute( (json:any, error:any) => {
        if (error) {
            AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR","ERROR"), error);
            return;
        }

        if (completion) completion();
    } );
}

WebService.prototype.updateBalanceFromAPI = function( account:BankAccount, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/open-banking/bank-account/" + account.identifier + "/update-balance";
    let r = new DLRequest ( url_str, {}, "GET" );
    r.execute( (json:any, error:any) => {
        if (error) {
            AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR","ERROR"), error);
            return;
        }

        if (completion) completion();
    } );
}
